import React from 'react';

const BadgeCounter = ({badgeNumber}) => (
    (badgeNumber !== parseInt(badgeNumber, 10) || badgeNumber < 1 ) ? null : <span className="badge badge-default">{badgeNumber}</span>
)

export default BadgeCounter;